// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MoRxu","newExpiryDate":"styles_newExpiryDate__LeOsT","footer":"styles_footer__d5QE4"};